import Component from "@tunnel-components/@pages/administration/home/component";
import * as React from "react";
import { connect } from "react-redux";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }      state
     */
    this.state = {};
  }
  /**
   * Cycle de vie d'un composant react
   * @method render
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return <Component {...this.props} {...this.state} />;
  }
}

/**
 * @function mapStateToProps
 * @param { any } state
 * @return { object }
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  return {};
}

/** @export HOC connect */
export default connect(mapStateToProps, {})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/home/container.tsx